import React from "react";
import Banner_01_old from "../../New_Web_design/Banner_01.png";
import Banner_02_old from "../../New_Web_design/Banner_02.png";
import Banner_01 from "../../New_Web_design/Banner_01.png";
import Banner_02 from "../../New_Web_design/Banner_02.png";
import Banner_03 from "../../New_Web_design/Banner_03.png";
import Banner_04 from "../../New_Web_design/Banner_04.png";

export default function ResonsTo() {
  return (
    <div className="mt-sm-5">
      <div style={{ backgroundColor: "#050810" }} className="p-3"></div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-7 col-lg-7 mt-4">
            <div className="px-4">
              <p
                className="sub-header mb-0  reasons-text"
                style={{
                  color: "#929498",
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                }}
              >
                Test Your Skills
              </p>
            </div>
            <div className="px-4">
              <p
                className="reasons-text"
                style={{
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                  color: "#f9c130",
                }}
              >
                <b>Play Games & Reward</b>
              </p>
            </div>
            <div className="p-4">
              <div style={{ height: "100%", width: "100%" }}>
                <img
                  src={Banner_01}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-5 col-lg-5 mt-4">
            <div className="px-4">
              <p
                className="sub-header mb-0 reasons-text"
                style={{
                  color: "#929498",
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                }}
              >
                Earn More
              </p>
            </div>
            <div className="px-4">
              <p
                className="reasons-text"
                style={{
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                  color: "#f9c130",
                }}
              >
                <b>Refer a friend</b>
              </p>
            </div>
            <div className="p-4">
              <div style={{ height: "100%", width: "100%" }}>
                <img
                  src={Banner_02}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-5 col-lg-5 mt-4">
            <div className="px-4">
              <p
                className="sub-header mb-0 reasons-text"
                style={{
                  color: "#929498",
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                }}
              >
                Our Team is at Service
              </p>
            </div>
            <div className="px-4">
              <p
                className="reasons-text"
                style={{
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                  color: "#f9c130",
                }}
              >
                <b>24 x 7 Support</b>
              </p>
            </div>
            <div className="p-4">
              <div style={{ height: "100%", width: "100%" }}>
                <img
                  src={Banner_03}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-7 col-lg-7 mt-4">
            <div className="px-4">
              <p
                className="sub-header mb-0  reasons-text"
                style={{
                  color: "#929498",
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                }}
              >
                Zero entry fee
              </p>
            </div>
            <div className="px-4">
              <p
                className="reasons-text"
                style={{
                  fontFamily: "JosefinSans",
                  fontSize: "25px",
                  color: "#f9c130",
                }}
              >
                <b>Big Tournaments</b>
              </p>
            </div>
            <div className="p-4">
              <div style={{ height: "100%", width: "100%" }}>
                <img
                  src={Banner_04}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
